import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";

export function useTableExcelExport(filename, sheet = filename) {
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename,
    sheet,
  });

  return { tableRef, onDownload };
}
